<!--
frontend-author:Pramoth,
backend-author: bhavya,
page-name :TaxDetails.vue,
page-description :Tax Summary,
started at : 15-April-2020.,
edited at :15-April-2020.
-->
<!-- Html code for aging details-->
<template>
  <div>
    <b-row class="reports-header px-pad border-bottom" style="height:42px">
        <b-col cols="6" xl="6" lg="6" md="6" sm="6" class="text-left px-0">
          <router-link
          class="event-link mt-2 float-left fw-semi-bold"
          :to="{name:'TaxSummary',query:oldRoute.query}"
        >
          <i class="la la-angle-left la-lg text-decoration-none mr-2"></i>Tax Summary
        </router-link>
       </b-col>
      <b-col xl="6" lg="6" md="6" sm="6" class="text-right px-0" cols="6">
        <router-link class="event-link float-right mt-2" :to="{ name : 'Reports'}">
          <i class="la la-remove la-lg text-decoration-none text-dark"></i>
        </router-link>

        <b-dropdown dropdown variant="light" size="sm" class="no-caret-dropdown float-right mr-2">
          <template slot="button-content">
            <i class="la la-navicon la-lg"></i>
          </template>
          <b-dropdown-item @click="exportModal()" class="dropdown-no-btn">
            <span class="la la-download mx-2"></span>Export Tax Details
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <div>
      <b-row class="pt-2">
        <b-col lg="12" xl="12" md="12" sm="12" class="px-0">
          <div class="text-center text-normal">
            <p class="mb-1">{{org_name}}</p>
            <h4 class="fw-semi-bold text-truncate">Tax for {{$route.params.title}}</h4>
            <p
              class="text-sm text-muted mb-2"
            >{{ 'From ' + getDateFormat(from_date) +' To '+ getDateFormat(to_date) }}</p>
          </div>
          <div class="table-responsive" id="reportScrollCol">
            <!--  sales by customer Table-->
            <table class="table table-bordered reports-table-border table-no-bordered">
              <!--  sales by customer Table head-->
              <thead class="tbl-col">
                <tr>
                  <th style="width:240px !important">
                    <router-link
                      :to="{ name : 'TaxDetails',params:{id:$route.params.id,title:$route.params.title},query: {report_by:$route.query.report_by,page: page,show: show,from_date:$route.query.from_date,to_date:$route.query.to_date,id:$route.query.id,title:$route.query.title,sort:sort == 'asc' ? 'desc' : 'asc',label:'date'} }"
                      class="text-dark text-decoration-none"
                    >
                      Date
                      <small class="text-muted" v-if="label == 'date'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="max-width:110px !important">
                    <router-link
                      :to="{ name : 'TaxDetails',params:{id:$route.params.id,title:$route.params.title},query: {report_by:$route.query.report_by,page: page,show: show,from_date:$route.query.from_date,to_date:$route.query.to_date,id:$route.query.id,title:$route.query.title,sort:sort == 'asc' ? 'desc' : 'asc',label:'code'} }"
                      class="text-dark text-decoration-none"
                    >
                      Code
                      <small class="text-muted" v-if="label == 'code'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="max-width:200px !important">
                    <router-link
                      :to="{ name : 'TaxDetails',params:{id:$route.params.id,title:$route.params.title},query: {report_by:$route.query.report_by,page: page,show: show,from_date:$route.query.from_date,to_date:$route.query.to_date,id:$route.query.id,title:$route.query.title,sort:sort == 'asc' ? 'desc' : 'asc',label:'type'} }"
                      class="text-dark text-decoration-none"
                    >
                      Type
                      <small class="text-muted" v-if="label == 'type'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width:200px !important" class="text-right">
                    <router-link
                      :to="{ name : 'TaxDetails',params:{id:$route.params.id,title:$route.params.title},query: {report_by:$route.query.report_by,page: page,show: show,from_date:$route.query.from_date,to_date:$route.query.to_date,id:$route.query.id,title:$route.query.title,sort:sort == 'asc' ? 'desc' : 'asc',label:'subtotal_without_tax'} }"
                      class="text-dark text-decoration-none"
                    >
                      Total without tax
                      <small
                        class="text-muted"
                        v-if="label == 'subtotal_without_tax'"
                      >
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width:200px !important" class="text-right">
                    <router-link
                      :to="{ name : 'TaxDetails',params:{id:$route.params.id,title:$route.params.title},query: {report_by:$route.query.report_by,page: page,show: show,from_date:$route.query.from_date,to_date:$route.query.to_date,id:$route.query.id,title:$route.query.title,sort:sort == 'asc' ? 'desc' : 'asc',label:'tax_amount'} }"
                      class="text-dark text-decoration-none"
                    >
                      Tax Amount
                      <small class="text-muted" v-if="label == 'tax_amount'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                </tr>
              </thead>
              <!--  Sales by Customer Table body and data -->
              <tbody>
                <tr v-if="lists.length==0">
                  <td colspan="5" class="text-center">No data to display.</td>
                </tr>
                <template v-else>
                  <tr v-for="(list,index) in lists" :key="index">
                    <td>{{getDateFormat(list.date)}}</td>
                    <td>{{ list.code }}</td>
                    <td>{{ list.type}}</td>
                    <td
                      class="text-right"
                    >{{orgCurrencySymbol+' '+Number(list.subtotal_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="text-right"
                    >{{orgCurrencySymbol+' '+Number(list.tax_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  </tr>
                  <tr>
                    <td colspan="3" class="text-bold">
                      <strong>Total</strong>
                    </td>
                    <td class="text-right text-bold">
                      <strong>{{orgCurrencySymbol+' '+Number(oldRoute.total_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</strong>
                    </td>
                    <td class="text-right text-bold">
                      <strong>{{orgCurrencySymbol+' '+Number(oldRoute.tax_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</strong>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
            <p class="ml-4" v-if="lists.length != 0">Amount is displayed in your base currency <b-badge
                variant="success"
                size="xs"
                style="height:20px"
              >{{orgCurrency}}</b-badge></p>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="lists.length > 0"
        style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
        class="px-pad"
      >
        <b-col xl="12" md="12" lg="12" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
          <nav class="float-right" v-if="typeof lists != 'undefined' && lists.length > 0">
            <ul class="pagination" style="cursor:pointer">
              <li
                :style="parseInt(page) == 1 ? 'pointer-events:none;opacity : 0.8' : ''"
                class="page-item"
              >
                <router-link
                  :to="{ name : 'TaxDetails',query: {page: parseInt(page) - 1,show: show,from_date:$route.query.from_date,to_date:$route.query.to_date,report_by:$route.query.report_by,id:$route.query.id,title:$route.query.title,sort:sort,label:$route.query.label} }"
                  class="text-dark text-decoration-none"
                >
                  <span
                    aria-hidden="true"
                    class="fw-semi-bold fa fa-angle-left mr-2"
                    style="margin-bottom : 4px"
                  ></span>
                </router-link>
              </li>
              <li
                class="page-item"
              >{{ ((page - 1) * show) + 1 || 0 }} to {{ ((page - 1) * show) + lists.length }}</li>

              <li
                :style="parseInt(count) == 0 ? 'pointer-events:none;opacity : 0.8' : ''"
                class="page-item"
              >
                <router-link
                  :to="{ name : 'TaxDetails',query: {page:parseInt(page) + 1,show: show,from_date:$route.query.from_date,to_date:$route.query.to_date,report_by:$route.query.report_by,id:$route.query.id,title:$route.query.title,sort:sort,label:$route.query.label} }"
                  class="text-dark text-decoration-none"
                >
                  <span
                    aria-hidden="true"
                    class="fw-semi-bold fa fa-angle-right ml-2"
                    style="margin-bottom : 4px"
                  ></span>
                </router-link>
              </li>
            </ul>
          </nav>
        </b-col>
      </b-row>
    </div>
    <GlobalExportModal
      v-if="export_modal"
      :data="export_data"
      :columns="export_xl"
      :file_name="'Tax Details'"
      @downloaded="export_modal=false"
    />
    <!--  back to top  -->
  </div>
</template>
<!-- Sales by Customer  Script -->
<script>
import vSelect from "vue-select"; // searchable select dropdwon
import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import moment from "moment";
import { formatDate } from "@/mixins/formatDate";

function getTaxDetails(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const sort = routeTo.query.sort || "";
  const label = routeTo.query.label || "";
  store
    .dispatch("reports/fetchTaxDetails", {
      page: currentPage,
      show: show,
      sort: sort,
      label: label,
      query: routeTo.query
    })
    .then(() => {
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.sort = sort;
      routeTo.params.label = label;
      next();
    });
}
export default {
  components: { vSelect },
  mixins: [formatDate],
  props: {
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    },
    label: [String, Number],
    sort: [String, Number]
  },
  name: "TaxDetails",
  data() {
    return {
      export_data: [],
      export_modal: false,
      from_date:
        this.$route.query.from_date ||
        this.formatDate(moment().startOf("month")),
      to_date:
        this.$route.query.to_date || this.formatDate(moment().endOf("month")),
      report_by: this.$route.query.report_by || 1,
      id: this.$route.query.id || 1,
      org_name: this.$AppDetails.organization.comp_name || "",
      export_xl: {
        Date: "date",
        Code: "code",
        Type: "type",
        "Total without tax": "subtotal_without_tax",
        "Tax amount": "tax_amount"
      }
    };
  },
  created() {
    this.$router.push({
      name: this.$route.name,
      query: {
        report_by:this.$route.query.report_by,
        page:1,
        show: 10,
        from_date: this.from_date,
        to_date: this.to_date,  
        id: this.$route.params.id,
        title: this.$route.params.title

      }
    });
  },
  methods: {
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
      this.$root.$emit("bv::show::modal", "exportdata");
    },
    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const response = await store
        .dispatch("reports/fetchTaxDetailExportLists", {
          page: currentPage,
          show: show,
          sort: sort,
          label: label,
          query: this.$route.query
        })
        .then(() => {
          return this.export;
        });

      return response;
    },

    getDateRange(event, runreport) {
      this.from_date = event.startDate;
      this.to_date = event.endDate;
      if (runreport == 1) {
        this.onRunReport();
      }
    }
  },

  beforeRouteEnter(routeTo, routeFrom, next) {
    getTaxDetails(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    getTaxDetails(routeTo, next);
  },
  computed: {
    ...mapState({
      lists: state => state.reports.lists,
      total_count: state => state.reports.total_count,
      count: state => state.reports.count,
      export: state => state.reports.export
    }),
    oldRoute: {
      get() {
        return this.$store.state.general.oldRoute;
      },
      set(val) {
        this.$store.state.general.oldRoute = val;
      }
    },
    ...mapGetters(["orgCurrencySymbol","orgCurrency"])
  }
};
</script>

<!--  Sales by Customer style -->
